import { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import ComparisonTable from './ComparisonTable';

export default function Table() {
  useEffect(() => {
    const urlParams = window.location.search;
    const button = document.getElementById('tableCtaButton') as HTMLAnchorElement;

    if (urlParams && button) {
      const cleanParams = urlParams.startsWith('?') ? urlParams.substring(1) : urlParams;
      const buttonUrl = new URL(button.href);
      buttonUrl.search = cleanParams;
      button.href = buttonUrl.toString();
    }
  }, []);

  return (
    <section className="py-16 relative overflow-hidden" id="compare">
      {/* Background accent */}
      <div className="absolute -left-40 bottom-0 w-[400px] h-[400px] rounded-full bg-[#6942E2] opacity-20 blur-3xl" />

      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">LawX vs outras IAs</h2>
          <p className="text-xl text-gray-300">
            Descubra por que a LawX é a escolha ideal para profissionais jurídicos
          </p>
        </div>

        <div className="backdrop-blur-lg bg-white/5 rounded-lg border border-white/10 p-6">
          <ComparisonTable />
          <div className="mt-8 text-center">
            {/* CTA Buttons with shining effect */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                id="tableCtaButton"
                href="https://plataforma.lawx.ai/dashboard" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group"
              >
                <button
                  className="group relative px-8 py-4 
                             bg-gradient-to-r from-[#4FC3F7] to-[#0B63F8] 
                             text-white rounded-lg font-semibold text-lg 
                             transition-all duration-300 
                             hover:shadow-[0_0_20px_rgba(11,99,248,0.4)] 
                             hover:scale-105 overflow-hidden w-full sm:w-auto"
                >
                  Teste grátis!
                  <ArrowRight className="inline-block ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
                  <div
                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent 
                               opacity-0 group-hover:opacity-100 
                               transform -translate-x-full skew-x-12 
                               group-hover:translate-x-full 
                               transition-transform duration-700 ease-in-out pointer-events-none"
                  />
                </button>
              </a>

              <a 
                href="https://api.whatsapp.com/send/?phone=558197225383&text=Ol%C3%A1%21+Quero+saber+mais+sobre+as+ferramentas+personalizadas%21&type=phone_number&app_absent=0" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group"
              >
                <button
                  className="group relative px-8 py-4 
                             bg-gradient-to-r from-[#25D366] to-[#128C7E] 
                             text-white rounded-lg font-semibold text-lg 
                             transition-all duration-300 
                             hover:shadow-[0_0_20px_rgba(37,211,102,0.4)] 
                             hover:scale-105 overflow-hidden w-full sm:w-auto"
                >
                  Solicitar ferramenta personalizada
                  <div
                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent 
                               opacity-0 group-hover:opacity-100 
                               transform -translate-x-full skew-x-12 
                               group-hover:translate-x-full 
                               transition-transform duration-700 ease-in-out pointer-events-none"
                  />
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}